<div
  mat-dialog-title
  appDraggableDialog
  draggableKey="filter-notes"
  [draggableWithRestrictArea]="true"
  dialogClass=".q9-filter-notes">
  <span>{{ 'POPUPS.FILTER_NOTES' | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<mat-dialog-content class="content">
  <span *ngIf="data.filterProp === 'author'">
    {{ 'POPUPS.FILTER_NOTES_USER_TEXT' | translate }}
  </span>
  <span *ngIf="data.filterProp === 'paperClass'">
    {{ 'POPUPS.FILTER_NOTES_COLOR_TEXT' | translate }}
  </span>
  <span *ngIf="data.filterProp === 'tags'">{{ 'POPUPS.FILTER_NOTES_TAG_TEXT' | translate }}</span>
  <mat-slide-toggle
    *ngFor="let resource of allResources"
    class="resource-toggle"
    (change)="toggleSelect(resource)"
    [checked]="isSelected(resource)">
    <div class="toggle-content" [ngSwitch]="data.filterProp">
      <span *ngSwitchCase="'paperClass'" [ngClass]="resource.key">
        <div class="paper color-rectangle"></div>
      </span>
      <span *ngSwitchCase="'author'">{{ resource.fullName | decodeHtml }}</span>
      <span *ngSwitchCase="'tags'" class="q9-tag-cell popup-tags">
        {{ resource.key | decodeHtml }}
      </span>
      <span>({{ resource.count }})</span>
    </div>
  </mat-slide-toggle>
</mat-dialog-content>

<mat-dialog-actions>
  <q9-secondary-button (click)="resetSelected()">
    {{ 'POPUPS.RESET' | translate }}
  </q9-secondary-button>
</mat-dialog-actions>
